<template>
  <div class="cochain">
    <div class="part-1">
      <div class="main">
        <div class="left">
          <span class="tit">{{ $t('message.slider1.title') }}</span>
          <p>{{ $t('message.slider1.description') }}</p>
        </div>
        <div class="right">
          <img src="../assets/images/message-bg-right.png" alt />
        </div>
      </div>
    </div>

    <div class="part-2">
      <div class="main">
        <!-- <hr class="fenge">
        <p class="tit">{{ $t('message.part1.title') }}</p>
        <p class="desc">{{ $t('message.part1.description') }}</p>-->
        <Tabs type="card">
          <!--公告-->
          <div class="show" v-show="message">
            <div class="tit">
              <Button
                      class="bottomon"
                      @click="messageshow"
              >{{$t('message.part2.tab4')}}</Button>
              <Button class="bottom" @click="weeklyshow">{{$t('message.part2.tab1')}}</Button>
              <Button class="bottom" @click="reportshow">{{$t('message.part2.tab2')}}</Button>
              <Button class="bottom"  @click="historyshow">{{$t('message.part2.tab3')}}</Button>
            </div>
            <div class="announcement" v-if="weeklyList.length > 0">
              <ul>
                <router-link
                        tag="li"
                        class="item"
                        v-for="item of weeklyList"
                        :key="item.id"
                        :to="'/announcementDetial?id=' + item.id"
                >
                  <div class="item-date">
                    <div class="item-date-head">{{item.day}}</div>
                    <div class="item-date-body">{{item.month}}</div>
                  </div>
                  <div class="item-info">
                    <p class="item-title">{{item.title}}</p>
                    <p class="item-desc">{{item.description}}</p>
                  </div>
                </router-link>
              </ul>
              <div class="more" v-if="showMore1" style="margin-top: 30px;">
                <Button
                        type="primary"
                        @click="loadMore1"
                        :loading="loadingMore1"
                        ghost
                >{{ $t('common.loadMore') }}</Button>
              </div>
              <div style="clear:both;display:block;height:30px;"></div>
            </div>
            <div class="spin1" v-else>
              <Spin size="large"></Spin>
            </div>
          </div>
          <!--周报-->
          <div class="show" v-show="weekly">
            <div class="tit">
              <Button class="bottom"  @click="messageshow">{{$t('message.part2.tab4')}}</Button>
              <Button class="bottomon" @click="weeklyshow">{{$t('message.part2.tab1')}}</Button>
              <Button class="bottom" @click="reportshow">{{$t('message.part2.tab2')}}</Button>
              <Button class="bottom"  @click="historyshow">{{$t('message.part2.tab3')}}</Button>
            </div>
            <div class="weekly" v-if="weeklyList.length > 0">
              <ul>
                <router-link
                        tag="li"
                        class="item"
                        v-for="item of list"
                        :key="item.id"
                        :to="'/weeklyDetail?id=' + item.id"
                >
                  <div class="item-date">
                    <div class="item-date-head">{{item.day}}</div>
                    <div class="item-date-body">{{item.month}}</div>
                  </div>
                  <div class="item-info">
                    <p class="item-title">{{item.title}}</p>
                    <p class="item-desc">{{item.description}}</p>
                  </div>
                </router-link>
              </ul>
              <div class="more" v-if="showMore3" style="margin-top: 30px;">
                <Button
                        type="primary"
                        @click="loadMore3"
                        :loading="loadingMore3"
                        ghost
                >{{ $t('common.loadMore') }}</Button>
              </div>
              <div style="clear:both;display:block;height:30px;"></div>
            </div>
            <div class="spin" v-else>
              <Spin size="large"></Spin>
            </div>
          </div>
          <!--媒体-->
          <div class="show" v-show="report">
            <div class="tit">
              <Button class="bottom"  @click="messageshow">{{$t('message.part2.tab4')}}</Button>
              <Button class="bottom"  @click="weeklyshow">{{$t('message.part2.tab1')}}</Button>
              <Button class="bottomon"  @click="reportshow">{{$t('message.part2.tab2')}}</Button>
              <Button class="bottom"  @click="historyshow">{{$t('message.part2.tab3')}}</Button>
            </div>
            <div class="report" v-if="reportList.length > 0">
              <ul>
                <router-link
                        tag="li"
                        class="item"
                        v-for="item of reportList"
                        :key="item.id"
                        :to="'/reportDetail?id=' + item.id"
                >
                  <div class="item-img">
                    <img :src="item.pic" width="260px" height="170px" />
                  </div>
                  <div class="item-info">
                    <div class="item-info-head">
                      <div class="item-title">{{item.title}}</div>
                    </div>
                    <div class="item-desc">{{item.description}}</div>
                    <div class="item-date">
                      <span>{{$t('messageDetail.itemdate')}}</span>
                      {{item.createdTime}}
                    </div>
                  </div>
                </router-link>
              </ul>
              <div class="more" v-if="showMore2">
                <Button
                        type="primary"
                        @click="loadMore2"
                        :loading="loadingMore2"
                        ghost
                >{{ $t('common.loadMore') }}</Button>
              </div>
              <div style="clear:both;display:block;height:30px;"></div>
            </div>
            <div class="spin" v-else>
              <Spin size="large"></Spin>
            </div>
          </div>
          <!--进程-->
          <div class="show" v-show="history">
            <div class="tit">
              <Button  class="bottom"  @click="messageshow">{{$t('message.part2.tab4')}}</Button>
              <Button class="bottom"  @click="weeklyshow">{{$t('message.part2.tab1')}}</Button>
              <Button class="bottom"  @click="reportshow">{{$t('message.part2.tab2')}}</Button>
              <Button class="bottomon"  @click="historyshow">{{$t('message.part2.tab3')}}</Button>
            </div>
            <div class="history" v-show="history">
              <div class="part">
                <Timeline>
                  <TimelineItem class="year19">
                    <div class="year" slot="dot">2018</div>
                  </TimelineItem>
                  <TimelineItem>
                    <Button type="primary" shape="circle" slot="dot">{{$t('history.icon1')}}</Button>
                    <span>{{$t('history.text1')}}</span>
                  </TimelineItem>
                  <TimelineItem>
                    <Button type="primary" shape="circle" slot="dot">{{$t('history.icon2')}}</Button>
                    <span>{{$t('history.text2')}}</span>
                  </TimelineItem>
                  <TimelineItem>
                    <Button type="primary" shape="circle" slot="dot">{{$t('history.icon3')}}</Button>
                    <span>{{$t('history.text3')}}</span>
                  </TimelineItem>
                  <TimelineItem>
                    <Button type="primary" shape="circle" slot="dot">{{$t('history.icon4')}}</Button>
                    <span>{{$t('history.text4')}}</span>
                  </TimelineItem>
                  <TimelineItem>
                    <Button type="primary" shape="circle" slot="dot">{{$t('history.icon5')}}</Button>
                    <span>{{$t('history.text5')}}</span>
                  </TimelineItem>
                  <TimelineItem>
                    <Button type="primary" shape="circle" slot="dot">{{$t('history.icon6')}}</Button>
                    <span>{{$t('history.text6')}}</span>
                  </TimelineItem>
                  <TimelineItem class="year19">
                    <div class="year" slot="dot">2017</div>
                  </TimelineItem>
                  <TimelineItem>
                    <Button type="primary" shape="circle" slot="dot">{{$t('history.icon7')}}</Button>
                    <span>{{$t('history.text7')}}</span>
                  </TimelineItem>
                  <TimelineItem>
                    <Button type="primary" shape="circle" slot="dot">{{$t('history.icon8')}}</Button>
                    <span>{{$t('history.text8')}}</span>
                  </TimelineItem>
                </Timeline>
              </div>
            </div>
          </div>
        </Tabs>
      </div>
    </div>
  </div>
</template>


<script>
  import {
    Tabs,
    TabPane,
    Button,
    Spin,
    Timeline,
    TimelineItem,
    Icon,
    Message
  } from "iview";
  import api from "../common/api";
  import defalt from '../assets/images/defalt.png'

  export default {
    name: "news",

    components: { Tabs, TabPane, Button, Spin, Timeline, TimelineItem, Icon },

    data() {
      return {
        weeklyList: [],
        page1: 1,
        rows1: 10,
        showMore1: false,
        loadingMore1: false,
        reportList: [],
        page2: 1,
        rows2: 10,
        showMore2: false,
        loadingMore2: false,
        lang: "en",
        message: true,
        weekly: false,
        report: false,
        history: false,
        list: [],
        page3: 1,
        rows3: 10,
        showMore3: false,
        loadingMore3: false,
        defalt
      };
    },

    created() {
      this.getImg();
      this.getNoticeList();
      this.getReportList();
      this.getWeeklyList()
    },

    methods: {
      getImg() {
        this.lang = localStorage.Lang || "en";
      },

      getWeeklyList() {
        this.$axios
                .get(api.getWeeklyList, {
                  params: {
                    rows: this.rows3,
                    page: this.page3
                  }
                }).then(res => {
          let data = res.data
          data.list.forEach(ele => {
            this.list.push({
              id: ele.id,
              title: ele.title,
              month: ele.createdTime.substring(0, 7),
              day: ele.createdTime.substring(8, 10),
              description: ele.description
            })
          })
          this.showMore3 =
                  this.rows3 * this.page3 < data.total ? true : false;
          this.loadingMore3 = false;
        }).catch(err => {
          console.log(err)
        })
      },

      getNoticeList() {
        this.$axios
                .get(api.getNoticeList, {
                  params: {
                    rows: this.rows1,
                    page: this.page1
                  }
                })
                .then(res => {
                  let list = res.data.list;
                  list.map(data => {
                    this.weeklyList.push({
                      id: data.id,
                      title: data.title,
                      month: data.createdTime.substring(0, 7),
                      day: data.createdTime.substring(8, 10),
                      description: data.description
                    });
                  });

                  this.showMore1 =
                          this.rows1 * this.page1 < res.data.total ? true : false;
                  this.loadingMore1 = false;
                })
                .catch(err => {
                  console.log(err);
                });
      },

      loadMore1() {
        this.page1++;
        this.loadingMore1 = true;
        this.getNoticeList();
      },

      getReportList() {
        this.$axios
                .get(api.getReportList, {
                  params: {
                    rows: this.rows2,
                    page: this.page2
                  }
                })
                .then(res => {
                  let list = res.data.list;
                  list.map(data => {
                    this.reportList.push({
                      id: data.id,
                      pic: data.picSmall || this.defalt,
                      title: data.title,
                      createdTime: data.createdTime.substring(0, 10),
                      description: data.description
                    });
                  });

                  this.showMore2 =
                          this.rows2 * this.page2 < res.data.total ? true : false;
                  this.loadingMore2 = false;
                })
                .catch(err => {
                  console.log(err);
                });
      },

      loadMore2() {
        this.page2++;
        this.loadingMore2 = true;
        this.getReportList();
      },
      loadMore3() {
        this.page3++;
        this.loadingMore3 = true;
        this.getWeeklyList();
      },
      messageshow() {
        this.message = true;
        this.weekly = false;
        this.report = false;
        this.history = false;
      },
      weeklyshow() {
        this.message = false;
        this.weekly = true;
        this.report = false;
        this.history = false;
      },
      reportshow() {
        this.message = false;
        this.weekly = false;
        this.report = true;
        this.history = false;
      },
      historyshow() {
        this.message = false;
        this.weekly = false;
        this.report = false;
        this.history = true;
      }
    }
  };
</script>

<style lang="less" scoped>
  @import url("../assets/css/var.less");
  .spin {
    display: inline-block;
    width: 40px;
    height: 40px;
    position: relative;
    background-color: #ffffff;
    padding: 100px 0;
  }
  .cochain {
    .part-1 {
      background: linear-gradient(
              81deg,
              rgba(28, 57, 176, 1),
              rgba(51, 119, 246, 1)
      );
      background-size: 100% 100%;
      background-repeat: no-repeat;
      height: 600px;
      .clearfix();
      .left {
        float: left;
        width: 53%;
        text-align: right;
        padding-right: 20px;
        padding-left: 6%;
        vertical-align: middle;
        color: #fff;

        .tit {
          display: block;
          margin-top: 240px;
          font-weight: bold;
          text-align: left;
          font-size: 66px;

          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }
        p {
          padding: 10px 0;
          text-align: left;

          font-size: 22px;

          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }
      }
      .right {
        float: left;
        width: 47%;
        text-align: left;
        vertical-align: middle;
        margin-top: 150px;
        img {
        }
      }
    }
    .part-2 {
      background: rgba(255, 255, 255, 1);
      //background-image:url("../assets/images/message-hoistory-bg.png");
      //background-size:100% 60% ;
      // background-position;
      .main {
        .tit {
          margin-bottom: 60px;
          font-size: 18px;
          .bottomon {
            margin-right: 5px;
            width: 220px;
            height: 50px;
            padding: 12px 60px;
            background-color:rgba(76,143,255,1);
            border-width: 0px;
            border-radius: 0px;
            font-size: 18px;
            font-weight: 400;
            color: #ffffff;

          }
          .bottom {
            margin-right: 5px;
            width: 220px;
            height: 50px;
            padding: 12px 50px;
            background-color: rgba(242, 241, 247, 1);
            border-width: 0px;
            border-radius: 0px;
            font-size: 18px;
            font-weight: 400;
            color: rgba(54, 54, 54, 1);
            &:hover {
              background-color: #75a9ff;
              color: #ffffff;
            }
          }
        }
        overflow: hidden;
      }
      .fenge {
        .fgx();
      }
      .tit {
        .part-tit();
      }
      .desc {
        .part-desc();
      }

      .more {
        text-align: center;
        padding: 5px 0;
      }
      .show {
        width: 100%;
        //公告
        .announcement {
          width: 100%;
          .item {
            height: 140px; //1
            overflow: hidden;
            display: flex;
            border-bottom: 1px solid #eee;
            margin-bottom: 20px;
            cursor: pointer; //鼠标

            .item-date {
              background-image: url("../assets/images/Information- announcement.jpg");
              background-size: 100% 100%;
              background-repeat: no-repeat;
              width: 19%; //2
              height: 100%;
              color: rgba(255, 255, 255, 1);
              .item-date-head {
                margin-top: 40px;
                margin-bottom: 24px;
                font-size: 48px;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);
                line-height: 30px;
              }

              .item-date-body {
                line-height: 20px;
                font-size: 24px;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);
              }
            }

            .item-info {
              flex: 1;
              min-width: 0;
              padding: 0 30px;
              height: 100%;
              width: 80%;
              .item-title {
                text-align: left;
                padding: 35px 0 10px 0;
                font-size: 22px;

                font-weight: 400;
                color: rgba(51, 51, 51, 1);
              }

              .item-desc {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                text-align: left;
                word-break: keep-all;
                text-overflow: ellipsis;
                font-size: 16px;
                font-weight: 400;
                color: rgba(153, 153, 153, 1);
              }
            }
            &:hover {
              background-color: #4e93f8;
              .item-title {
                color: #fff;
              }
              .item-desc {
                color: #fff;
              }
              .item-date {
                color: #fff;
                background-color: #71a8f8;
              }
            }
          }
        }
        .weekly {
          width: 100%;
          .item {
            height: 140px; //1
            overflow: hidden;
            display: flex;
            border-bottom: 1px solid #eee;
            margin-bottom: 20px;
            cursor: pointer; //鼠标

            .item-date {
              background-image: url("../assets/images/Information- week.jpg");
              background-size: 100% 100%;
              background-repeat: no-repeat;
              width: 19%; //2
              height: 100%;
              color: rgba(255, 255, 255, 1);
              .item-date-head {
                margin-top: 40px;
                margin-bottom: 24px;
                font-size: 48px;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);
                line-height: 30px;
              }

              .item-date-body {
                line-height: 20px;
                font-size: 24px;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);
              }
            }

            .item-info {
              flex: 1;
              min-width: 0;
              padding: 0 30px;
              height: 100%;
              width: 80%;
              .item-title {
                text-align: left;
                padding: 35px 0 10px 0;
                font-size: 22px;

                font-weight: 400;
                color: rgba(51, 51, 51, 1);
              }

              .item-desc {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                text-align: left;
                word-break: keep-all;
                text-overflow: ellipsis;
                font-size: 16px;
                font-weight: 400;
                color: rgba(153, 153, 153, 1);
              }
            }
            &:hover {
              background-color: #4e93f8;
              .item-title {
                color: #fff;
              }
              .item-desc {
                color: #fff;
              }
              .item-date {
                color: #fff;
                background-color: #71a8f8;
              }
            }
          }
        }

        .report {
          width: 100%;
          .item {
            overflow: hidden;
            display: flex;
            margin-bottom: 30px;
            height: 170px;
            cursor: pointer;

            .item-img {
              width: 260px;
              height: 100%;
            }

            .item-info {
              flex: 1;
              height: 100%;
              padding: 0 40px;
              min-width: 0;
              border-bottom: 1px dashed #ccc;

              .item-info-head {
                height: 52px;
                width: 100%;
                line-height: 26px;

                .item-title {
                  float: left;
                  //overflow: hidden;
                  //white-space: nowrap;
                  // text-overflow: ellipsis;
                  text-align: left;
                  font-size: 22px;
                  font-weight: 400;
                  color: rgba(51, 51, 51, 1);
                }
              }

              .item-desc {
                margin-top: 20px;
                height: 17px;
                width: 94%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                line-height: 17px;
                text-align: left;
                font-size: 16px;
                font-weight: 400;
                color: rgba(153, 153, 153, 1);
              }
              .item-date {
                margin-top: 43px;
                float: left;
                font-size: 16px;
                font-weight: 400;
                color: rgba(153, 153, 153, 1);
              }
            }
          }
        }
        //发展历程
        .history {
          padding-left: 170px;
          //background-image:url("../assets/images/message-hoistory-bg.png");
          .year {
            display: inline-block;
            margin-right: 97%;
            text-align: center;
            padding-top: 31px;
            width: 86px;
            height: 86px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(76, 143, 255, 1);
            border-radius: 50%;
            font-size: 24px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
          /deep/.ivu-btn {
            width: 61px;
            height: 29px;
            background: rgba(76, 143, 255, 1);
            border: 1px solid rgba(76, 143, 255, 1);
            border-radius: 15px;
            font-size: 18px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            padding: 0 1px 3px 0;
            line-height: 0;
          }
        }
      }
    }
  }
  /deep/.ivu-tabs-bar {
    border-bottom: none;
  }
  /deep/.ivu-tabs.ivu-tabs-card {
    margin-top: 60px;
    padding-left: 10px;
  }
  /deep/.ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
    border-bottom: 1px solid #dcdee2;
    border-radius: 4px 4px 4px 4px;
  }
  /deep/.ivu-tabs {
    text-align: center;
  }
  /deep/.ivu-tabs-nav {
    float: none;
  }
  .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-nav-container {
    height: 100%;
  }
  /deep/.ivu-tabs-nav-wrap {
    height: 100%;
  }
  /deep/.ivu-tabs-nav-scroll {
    height: 100%;
  }
  /deep/.ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
    background-color: #f2f1f7;
    border-color: #f2f1f7;
    color: #1e1e1e;
    border-radius: 2px;
  }
  /deep/.ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-nav-container {
    height: 100%;
  }
  /deep/.ivu-tabs-nav-container {
    font-size: 18px;
    font-weight: 400;
  }
  /deep/.ivu-tabs-nav-container:focus .ivu-tabs-tab-focused {
    border-color: #4c90ff !important;
    background-color: #4c90ff !important;
    color: #fff !important;
  }
  /deep/.ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
    padding: 13px 52px;
    height: 100%;
    width: 175px;
  }

  //发展历程

  /deep/.ivu-timeline-item {
    margin: 30px 0px !important;
    padding: 0;
    height: 86px;
  }
  /deep/.ivu-timeline-item-head-custom {
    width: 86px;
    left: 0;
    padding: 0;
    margin-top: 42px;
  }
  /deep/.ivu-timeline-item-tail {
    height: 120%;
    left: 42px;
    top: 49px;
    border-left: 1px solid rgba(215, 215, 215, 1);
  }
  /deep/.ivu-timeline-item-content {
    font-size: 20px;
    font-weight: 400;
    color: rgba(0, 0, 0, 1);
    padding: 30px 1px 0px 120px;
    text-align: left;
  }
</style>

